module.exports = __webpack_public_path__ + "img/parking-navigation.2615974e.png";